/**
 * SUPABASE CLIENT - STANDARD CONFIGURATION
 * 
 * Re-initialized to official defaults.
 * Flow: PKCE (Standard for security)
 */

import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://eihlnkgjwxqbyvqbgcdx.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVpaGxua2dqd3hxYnl2cWJnY2R4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc3MzQwODUsImV4cCI6MjA2MzMxMDA4NX0.NaeyDgyLuhe7mldsSc8diMwwlPDW8WZs2tfXHkuvIQI'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  },
  global: {
    headers: {
      'apikey': SUPABASE_ANON_KEY,
    },
  },
})

export type { User, Session } from '@supabase/supabase-js'
